import { Maybe, ProductType } from 'types/schema-generated-types';

const getApplicationType = (types?: Array<Maybe<ProductType>>): string => {
  if (!types) return 'Application';
  const typeStrings = types.map((type: Maybe<ProductType>): string => {
    if (type === ProductType.USER) {
      return 'Teacher';
    }
    return 'Student';
  });
  return `${typeStrings.join(', ')} Application`;
};

export default getApplicationType;
